import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { errorMessage, successMessage } from "../../Errors/Toast";
import commonApi from "../../CommonApi/CommonServices";
import { Button, Form, NavLink } from "react-bootstrap";
import { get_user_info } from "../../Redux/userProfileAction";
import { onBoarding, verify_email } from "../../Redux/LoginAction";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { resume_profile_data } from "../../Redux/ResumeAction";
import { user_profile_info } from "../../Redux/ProfileAction";

const VerifyEmailModal = (props) => {
  const [codes, setCodes] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);
  const buttonRef = useRef([]);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [isAnotherEmail, setIsAnotherEmail] = useState(false);
  const [showValidEmail, setShowValidEmail] = useState('');
  const [userEmail, setUserEmail] = useState("");
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const loginUser = useSelector((state) => state.rootReducer?.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.autoStart && props.timer === 60 && !props.startTimer) {
      props.setStartTimer(true); // only auto-start in autoStart=true mode
    }

    // NEW: Enable resend button if timer is not running
    if (!props.startTimer || props.timer === 0) {
      setIsResendDisabled(false);
    } else {
      setIsResendDisabled(true);
    }
  }, [props.autoStart, props.startTimer, props.timer]);

  useEffect(()=>{
    setShowValidEmail(props.email)
  },[props.email])

  const handleChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newCodes = [...codes];
      newCodes[index] = value;
      setCodes(newCodes);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !codes[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handle = () => {
    if (codes.length === 6 && codes.every((digit) => digit !== "")) {
      verify_email_code();
    } else {
      errorMessage("Please enter a valid 6-digit OTP.");
    }
  };

  const verify_email_code = () => {
    const formData = new FormData();
    const finalCode = codes.join("");
    formData.append("email", showValidEmail);
    formData.append("code", Number(finalCode));

    commonApi
      .verify_email_code(formData, loginUser?.token)
      .then((res) => {
        if (res.success) {
          successMessage(res.message);
          localStorage.setItem("verfied", true);
          dispatch(verify_email(true));
          dispatch(user_profile_info("", loginUser?.token));
          dispatch(resume_profile_data("", loginUser?.token));
          navigate("/journey");
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const resend_code = () => {
    const formData = new FormData();
    formData.append("email", showValidEmail);

    commonApi
      .resend_code(formData, loginUser?.token)
      .then((res) => {
        if (res.success === true) {
          successMessage(res.message);
          props.setTimer(60);
          props.setStartTimer(true);
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const change_email = () => {
    const formData = new FormData();
    formData.append("new_email", userEmail);

    commonApi
      .change_email(formData, loginUser?.token)
      .then((res) => {
        if (res.success === true) {
          successMessage(res.message);
          setIsAnotherEmail(false);
          props.setTimer(60);
          props.setStartTimer(true);
          setShowValidEmail(userEmail)
          setUserEmail("");
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return "";
    const [user, domain] = email.split("@");
    const visible = user.slice(0, 2);
    const masked = "*".repeat(Math.max(user.length - 2, 4));
    return `${visible}${masked}@${domain}`;
  };

  const handleAnotherEmail = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      event.preventDefault();
      setValidated(false);
      change_email();
    }
  };

  return (
    <Modal
      id="join-modal"
      className="custom-modal1 custom-modal2 custom-modal3"
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <i className="fa-solid fa-xmark" onClick={() => props.onHide()}></i>
      </Modal.Header>
      <Modal.Body>
        <div className="gets-started-form-contain p-0 bg-transparent">
          <div className="gets-started-holder gets-started-form-holder p-0">
            <div className="form-holder">
              <h3 style={{ fontWeight: 600, textAlign: "center" }}>
                {!isAnotherEmail && "Verify your Email"}
              </h3>
              {!isAnotherEmail && (
                <p
                  style={{ fontWeight: 600, textAlign: "center" }}
                  className="font-size"
                >
                  {maskEmail(showValidEmail)}
                </p>
              )}
              <div className="text-center m-2">
                <button
                  className="btn btn-link p-0 m-0"
                  style={{
                    fontSize: "14px",
                    color: "#54aad6",
                    textDecoration: "underline",
                    fontWeight: 500,
                  }}
                  onClick={() => {
                    if (isAnotherEmail) {
                      setIsAnotherEmail(false);
                    } else {
                      setIsAnotherEmail(true);
                    }
                    setUserEmail("");
                    setCodes(Array(6).fill(""));
                  }}
                >
                  {isAnotherEmail
                    ? "Back to code entry"
                    : "Use a different email"}
                </button>
              </div>
              {isAnotherEmail ? (
                <>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleAnotherEmail}
                  >
                    <div className="form-group get-started-form">
                      <Form.Label htmlFor="email" className="font-size">
                        Enter a different email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        required
                        placeholder=""
                        autoComplete="off"
                        value={userEmail}
                        onChange={(e) => {
                          setUserEmail(e.target.value);
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {userEmail ? "Email is invalid." : "Email is required."}
                      </Form.Control.Feedback>
                    </div>
                    <Button
                      style={{ display: "none" }}
                      ref={buttonRef}
                      type="submit"
                    ></Button>
                  </Form>
                </>
              ) : (
                <div className="d-flex gap-2 justify-content-center mt-4">
                  {codes.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      className="code-input text-center"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center w-100">
          <div className="d-flex align-items-center gap-3">
            <button
              type="submit"
              className="custm-selct-icon-btn btn btn-primary btn-md"
              // style={{ width: isAnotherEmail ? "150px" : "120px" }}
              onClick={() => {
                if (!isAnotherEmail) {
                  handle();
                } else {
                  buttonRef.current.click();
                }
              }}
            >
              {isAnotherEmail ? "Resend code" : "Verify"}
            </button>
            {!isAnotherEmail && (
              <NavLink
                className={`account-anchor account-anchor-hover font-size ${
                  isResendDisabled ? "disabled" : ""
                }`}
                onClick={() => {
                  if (!isResendDisabled) resend_code();
                }}
                style={{
                  pointerEvents: isResendDisabled ? "none" : "auto",
                  opacity: isResendDisabled ? 0.5 : 1,
                  textDecoration: "none",
                  marginTop: "4px",
                }}
              >
                Resend Code{" "}
                {props.startTimer && isResendDisabled && `(${props.timer}s)`}
              </NavLink>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyEmailModal;
